import React from 'react';
import './Pagination.css';

// Component for handling page navigation in search results
function Pagination({ currentPage, totalPages, onPageChange }) {
  return (
    <div className="pagination">
      {/* Previous page button */}
      <button 
        className="page-button" 
        // Disable button if we're on the first page
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        Previous
      </button>

      {/* Current page indicator */}
      <span className="page-number">
        Page {currentPage}
      </span>

      {/* Next page button */}
      <button 
        className="page-button"
        // Disable button if we're on the last page
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
      </button>
    </div>
  );
}

export default Pagination;
